import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import * as S from "../svg.style";
export var Minus = function(_param) /*#__PURE__*/ {
    var color = _param.color, height = _param.height, width = _param.width, shrinkable = _param.shrinkable, rest = _object_without_properties(_param, [
        "color",
        "height",
        "width",
        "shrinkable"
    ]);
    return _jsx(S.Svg, _object_spread_props(_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        height: height,
        width: width,
        viewBox: "0 0 24 24",
        shrinkable: shrinkable
    }, rest), {
        children: /*#__PURE__*/ _jsx("path", {
            stroke: color,
            strokeLinecap: "round",
            strokeMiterlimit: "10",
            d: "M19.375 12H4.625"
        })
    }));
};
